import React, { useState } from 'react';
import styled from 'styled-components';
import Login from './Login';
import Register from './Register';

const AuthContainer = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AuthCard = styled.div`
  background: white;
  width: 100%;
  max-width: 400px;
  margin: 40px auto;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const TabContainer = styled.div`
  display: flex;
  background: white;
  border-bottom: 1px solid #e1e3e6;
`;

const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 16px;
  font-size: 1rem;
  color: ${props => props.active ? '#1a73e8' : '#5f6368'};
  background: none;
  border: none;
  border-bottom: 2px solid ${props => props.active ? '#1a73e8' : 'transparent'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${props => props.active ? '500' : 'normal'};
  
  &:hover {
    color: #1a73e8;
    background: ${props => props.active ? 'transparent' : '#f8f9fa'};
  }

  &:focus {
    outline: none;
  }
`;

const FormContainer = styled.div`
  background: white;
`;

const Auth: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');

  return (
    <AuthContainer>
      <AuthCard>
        <TabContainer>
          <Tab
            active={activeTab === 'login'}
            onClick={() => setActiveTab('login')}
          >
            登录
          </Tab>
          <Tab
            active={activeTab === 'register'}
            onClick={() => setActiveTab('register')}
          >
            注册
          </Tab>
        </TabContainer>
        <FormContainer>
          {activeTab === 'login' ? <Login /> : <Register />}
        </FormContainer>
      </AuthCard>
    </AuthContainer>
  );
};

export default Auth; 